import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import React from "react";
import {FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, Typography} from "@mui/material";
import {useFormik} from "formik";
import {API_SPEC} from "../../spec/apiSpec";
import {useApi} from "../../hooks/api-hook";
import {useKeycloak} from "@react-keycloak/web";
import * as yup from 'yup';
import {conditions} from "./definition";
import AddCardToCollectionSelects from "./AddCardToCollectionSelects";
import {NumericFormat} from "react-number-format";
import ReactGA from "react-ga4";


const validationSchema = yup.object().shape({
/*
    price: yup
        .number().typeError('cena musi być liczbą')
        .required('cena jest wymagana'),
*/
});

export default function AddCardToCollection({open, handleClose, id, name}) {

    const {isLoading, data, api, initialized} = useApi();
    const {keycloak, initialized: ki} = useKeycloak();

    const formik = useFormik({
        initialValues: {
            cardId: id,
            condition: 'NM',
            foil: false,
            active: true,
            offerType: true, //true: sell, false: want
            quantity: 1,
            collectionName: 'Main collection',
            price: 0,
        },
        validationSchema,
        onSubmit: (values, {resetForm}) => {
            const data = {
                ...values,
                cardId: id,
                price: values.price.replace(',', '.').replaceAll(' ', '')  * 100
            }
            const collection_add = API_SPEC.COLLECTION_ADD(data)
            api(collection_add);
            resetForm();
            ReactGA.event({category: "collection", action: 'AddCardToCollection'});
        }
    });

    const offerTypeChange = (event) => {
        formik.setFieldValue('offerType', event.target.value === 'true')
    }

    const activeChange = (event) => {
        formik.setFieldValue('active', event.target.checked)
    }

    const foilChange = (event) => {
        formik.setFieldValue('foil', event.target.checked)
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Add a card to your collection</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography>{name} {id}</Typography>
                    </DialogContentText>
                    {!id && <AddCardToCollectionSelects/>}
                    <RadioGroup sx={{margin: 1}}
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={offerTypeChange}
                    >
                        <FormControlLabel value="true" control={<Radio checked={formik.values.offerType} value={true}/>}
                                          label="Have"/>
                        <FormControlLabel value="false"
                                          control={<Radio checked={!formik.values.offerType} value={false}/>}
                                          label="Want"/>
                    </RadioGroup>
                    {/* <FormControl variant="standard" sx={{margin: 1}}>
                        <InputLabel id="demo-simple-select-standard-label">Condition</InputLabel>
                        <Select
                            id="collectionName"
                            name="collectionName"
                            fullWidth
                            value={formik.values.collectionName}
                            onChange={formik.handleChange}
                            label="Collection"
                        >
                            <MenuItem value={'Main collection'}>Main collection</MenuItem>
                        </Select>
                    </FormControl> */}
                    {/* <TextField sx={{margin: 1}}
                               autoFocus
                               id="name"
                               name="name"
                               disabled
                               fullWidth
                               value={formik.values.name}
                               variant="standard"
                    /> */}
                    {/* <FormControlLabel
                        control={<Switch
                            id="active"
                            name='active'
                            label="Active"
                            checked={formik.values.active}
                            onChange={activeChange}/>}
                        label="For sale"/> */}
                    <FormControlLabel sx={{margin: 1}}
                        control={<Switch
                            id="foil"
                            name='foil'
                            label="Foil"
                            checked={formik.values.foil}
                            onChange={foilChange}/>}
                        label="Foil"/>
                    <FormControl  variant="outlined" sx={{margin: 1}}>
                        <InputLabel id="demo-simple-select-standard-label">Condition</InputLabel>
                        <Select
                            id="condition"
                            name="condition"
                            value={formik.values.condition}
                            onChange={formik.handleChange}
                            label="Condition"
                        >
                            {Object.keys(conditions).map(k => (<MenuItem value={k}>{conditions[k]}</MenuItem>))}
                        </Select>
                    </FormControl><br />
                    <TextField sx={{margin: 1}}
                               autoFocus
                               id="quantity"
                               name='quantity'
                               label="Quantity"
                               type='text'
                               variant="outlined"
                               onChange={formik.handleChange}
                               value={formik.values.quantity}
                               error={formik.touched.price && Boolean(formik.errors.quantity)}
                               helperText={formik.touched.price && formik.errors.quantity}
                    />
                    <NumericFormat
                        allowNegative={false}
                        thousandSeparator={' '}
                        decimalScale={2}
                        decimalSeparator={','}
                        allowedDecimalSeparators={['.', ","]}
                        customInput={TextField}
                        autoFocus
                        sx={{margin: 1}}
                        id="price"
                        name="price"
                        variant={'outlined'}
                        label='Price (zł)'
                        onChange={formik.handleChange}
                        value={formik.values.price}
                        error={formik.touched.price && !!formik.errors.price}
                        helperText={formik.touched.price && formik.errors.price}
                    />
                    <TextField sx={{margin: 1}}
                               id="notes"
                               name="notes"
                               label="Notes"
                               variant="outlined"
                               multiline
                               fullWidth
                               rows={1}
                               onChange={formik.handleChange}
                               value={formik.values.notes}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button disabled={!formik.isValid} type={'submit'} onClick={handleClose}>Add</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}
